import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';

import Team from './Team';

function TeamChoice({ title, teams, onClick }) {
  return (
    <Row className="flex-column mx-1 mb-5 p-light">
      <div>
        <p>{title} :</p>
      </div>
      <div className="align-self-center d-flex justify-content-around flex-wrap">
        {teams.map(team => {
          return <Team {...team} key={team.uuid} onClick={onClick} />;
        })}
      </div>
    </Row>
  );
}

export default TeamChoice;

TeamChoice.propTypes = {
  title: PropTypes.string,
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
      logo: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      uuid: PropTypes.string.isRequired,
      users: PropTypes.arrayOf(
        PropTypes.shape({
          TeamUuid: PropTypes.string.isRequired,
          uuid: PropTypes.string.isRequired,
          pseudo: PropTypes.string.isRequired,
          score: PropTypes.number.isRequired,
          createdAt: PropTypes.string,
          updatedAt: PropTypes.string
        })
      )
    })
  ).isRequired
};

TeamChoice.defaultProps = {
  title: 'Choose',
  teams: []
};
